module.exports = __webpack_public_path__ + "media/images/img-travel-10-95b7f183.jpg";